import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './admin-audit-history.reducer';
import { IAdminAuditHistory } from 'app/shared/model/admin-audit-history.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAdminAuditHistoryProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const AdminAuditHistory = (props: IAdminAuditHistoryProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { adminAuditHistoryList, match, loading } = props;
  return (
    <div>
      <h2 id="admin-audit-history-heading">
        Admin Audit Histories
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new Admin Audit History
        </Link>
      </h2>
      <div className="table-responsive">
        {adminAuditHistoryList && adminAuditHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>New Json</th>
                <th>Old Json</th>
                <th>Type</th>
                <th>Subscription History Id</th>
                <th>Subscription Plan Id</th>
                <th>Updated By</th>
                <th>Updated On</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {adminAuditHistoryList.map((adminAuditHistory, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${adminAuditHistory.id}`} color="link" size="sm">
                      {adminAuditHistory.id}
                    </Button>
                  </td>
                  <td>{adminAuditHistory.newJson}</td>
                  <td>{adminAuditHistory.oldJson}</td>
                  <td>{adminAuditHistory.type}</td>
                  <td>{adminAuditHistory.subscriptionHistoryId}</td>
                  <td>{adminAuditHistory.subscriptionPlanId}</td>
                  <td>{adminAuditHistory.updatedBy}</td>
                  <td>
                    {adminAuditHistory.updatedOn ? (
                      <TextFormat type="date" value={adminAuditHistory.updatedOn} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${adminAuditHistory.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${adminAuditHistory.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${adminAuditHistory.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Admin Audit Histories found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ adminAuditHistory }: IRootState) => ({
  adminAuditHistoryList: adminAuditHistory.entities,
  loading: adminAuditHistory.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AdminAuditHistory);
